import Vue from "vue";
import VueRouter from "vue-router";
import Accueil from "../views/Accueil.vue";
import Sentiers from "../views/Sentiers.vue";
import Map from "../views/Map.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Accueil",
    component: Accueil,
  },{
    path: "/sentiers",
    name: "Sentiers",
    component: Sentiers,
  },{
    path: "/map",
    name: "Map",
    component: Map,
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});

export default router;
